const KWH_USED_DAILY_BY_AVERAGE_US_HOME = 30;
// from https://www.eia.gov/tools/faqs/faq.php?id=97&t=3

// TODO update to remove undefined after release
export const convertKwhToEquivalent = (kwh?: number): number => {
  if (!kwh) return 0;
  return Math.round(kwh / KWH_USED_DAILY_BY_AVERAGE_US_HOME);
};
